import * as React from 'react';
const SvgArrowTrendUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#92999F"
      d="M18.542 5.708a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0v-1.94l-4.97 4.97a.75.75 0 0 1-1.06 0l-4.47-4.47-5.303 5.304a.75.75 0 1 1-1.06-1.061L6.76 7.178a.75.75 0 0 1 1.06 0l4.47 4.47 4.44-4.44h-1.94a.75.75 0 0 1 0-1.5z"
    />
  </svg>
);
export default SvgArrowTrendUp;
